import React, { useState } from 'react';
import VoiceInput from './VoiceInput';
import './FoodInput.css';

function FoodInput({ onSubmit, onVoiceInput }) {
  const [input, setInput] = useState('');
  const [selectedGoal, setSelectedGoal] = useState('maintain');
  const [targetCalories, setTargetCalories] = useState(2000);
  const [targetProtein, setTargetProtein] = useState(150);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!input.trim()) {
      alert('Please enter the foods you have');
      return;
    }
    
    onSubmit(input, { 
      goal: selectedGoal, 
      calories: targetCalories,
      protein: targetProtein 
    });
  };

  const handleVoiceInput = (transcript) => {
    setInput(transcript);
    onVoiceInput && onVoiceInput(transcript);
  };

  return (
    <div className="food-input-container">
      <div className="welcome-section">
        <h1>👋 Welcome to FitPrep AI</h1>
        <p>Plan your weekly meals & workouts with AI</p>
      </div>

      <form onSubmit={handleSubmit} className="food-input-form">
        <div className="input-group">
          <label htmlFor="food-input">What foods do you have?</label>
          <textarea
            id="food-input"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Example: I have chicken, rice, eggs, broccoli, and oatmeal for this week..."
            rows="3"
            required
          />
        </div>

        <div className="voice-input-wrapper">
          <VoiceInput onTranscript={handleVoiceInput} />
        </div>

        <div className="preferences">
          <div className="preference-group">
            <label htmlFor="goal">Fitness Goal:</label>
            <select
              id="goal"
              value={selectedGoal}
              onChange={(e) => setSelectedGoal(e.target.value)}
            >
              <option value="cut">Cut (Fat Loss)</option>
              <option value="maintain">Maintain (Balance)</option>
              <option value="bulk">Bulk (Muscle Building)</option>
            </select>
          </div>

          <div className="preference-group">
            <label htmlFor="calories">Daily Calories (kcal):</label>
            <input
              id="calories"
              type="number"
              min="1000"
              max="4000"
              step="100"
              value={targetCalories}
              onChange={(e) => setTargetCalories(parseInt(e.target.value))}
            />
          </div>

          <div className="preference-group">
            <label htmlFor="protein">Daily Protein (g):</label>
            <input
              id="protein"
              type="number"
              min="50"
              max="300"
              step="10"
              value={targetProtein}
              onChange={(e) => setTargetProtein(parseInt(e.target.value))}
            />
          </div>
        </div>

        <button type="submit" className="generate-button">
          ✨ Generate My 7-Day Plan
        </button>
      </form>
    </div>
  );
}

export default FoodInput;
